const MvtryBillComponent = () => import('@/views/WareHouse/MvtryBill/MvtryBillView')

export default [
    {
        path:'/MvtryBillIndex',
        name:'MvtryBillComponent',
        component:MvtryBillComponent
    }
]